import { initializeIcons } from "@uifabric/icons";
import "bootstrap/dist/css/bootstrap.css";
import Keycloak, { KeycloakConfig } from "keycloak-js";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter as Router, Route } from "react-router-dom";
import App from "./App";
import DisplayPackage from "./DisplayPackage/DisplayPackage";
import "./index.css";
import Upload from "./Upload";


const keycloakConfig: KeycloakConfig = {
  realm: "skynet",
  url: "https://login.winby.es/auth",
  clientId: "nugetServer",
};

const keycloak: Keycloak.KeycloakInstance = Keycloak(keycloakConfig);

// import registerServiceWorker from './registerServiceWorker';

initializeIcons();
keycloak
  .init({ onLoad: "login-required" })
  .success(() => {
    ReactDOM.render(
      <Router>
        <App>
          <Route path="/packages/:id/:version?" component={DisplayPackage} />

          <Route path="/upload" component={Upload} />
        </App>
      </Router>,
      document.getElementById("root") as HTMLElement
    );
  })
  .error((error) => console.log(error));
// registerServiceWorker();
